<template>
  <div class="courses">
    <div class="container">
      <div class="page-header">
        <h1 class="h1-title text-[#0E1F52] mb-4">全部课程</h1>
        <p>古杉数据 · 开卷有益 — 覆盖企业内训、中高管研修、AI专项实战、审计风控实训、认证培训等方向</p>
      </div>

      <!-- ===== 课程类型筛选 ===== -->
      <section class="section-padding bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 class="h2-title text-center text-[#0E1F52] mb-8">按类型浏览课程</h2>
          <div class="flex flex-wrap justify-center gap-4">
            <span
              v-for="cat in categories"
              :key="cat"
              class="px-6 py-3 rounded-full border text-base font-medium cursor-pointer transition"
              :class="activeCategory === cat
                ? 'bg-brand text-white border-brand'
                : 'bg-porcelain text-[#0E1F52] border-divider hover:bg-brand hover:text-white'"
              @click="activeCategory = cat"
            >{{ cat }}</span>
          </div>
          <!-- 统计 -->
          <div class="mt-12 grid grid-cols-2 md:grid-cols-6 gap-4 text-center">
            <div v-for="s in stats" :key="s.label">
              <span class="text-3xl font-bold text-brand">{{ s.count }}</span>
              <p class="text-sm text-[#5A5E66]">{{ s.label }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== 课程卡片网格 ===== -->
      <section class="cases-grid">
        <div
          class="case-card"
          v-for="course in filteredCourses"
          :key="course.id"
          @click="goToDetail(course)"
        >
          <div class="case-image" :style="{ background: course.gradient }">
            <div class="case-placeholder">{{ course.name }}</div>
          </div>
          <div class="case-content">
            <h3>{{ course.name }}</h3>
            <p class="company">{{ course.category }}</p>
            <p class="description">{{ course.summary }}</p>
            <div class="case-tags">
              <span v-for="tag in course.tags" :key="tag" class="tag">{{ tag }}</span>
            </div>
            <div class="mt-4 flex items-center justify-between">
              <span class="text-[#1F3F8F]">{{ course.caseText }}</span>
              <span class="text-xs text-[#5A5E66]">{{ course.date }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 返回培训中心 -->
      <div class="text-center mt-12">
        <router-link to="/training" class="inline-block px-8 py-3 border border-brand text-brand rounded-md hover:bg-porcelain transition">返回培训中心</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AllCourses',
  data() {
    return {
      activeCategory: '全部',
      categories: [
        '全部',
        '企业内训',
        '中高管研修',
        'AI专项实战',
        '审计风控实训',
        '认证培训',
        '2026 计划'
      ],
      stats: [
        { count: '7+',  label: '企业内训' },
        { count: '3+',  label: '中高管研修' },
        { count: '4+',  label: 'AI专项实战' },
        { count: '3+',  label: '审计风控实训' },
        { count: '3+',  label: '认证培训' },
        { count: '1',   label: '年度计划' }
      ],
      courses: [
        {
          id: 1,
          name: '财务数据分析（中高级）',
          category: '企业内训（培训 + 工信部证书）',
          filterCat: '企业内训',
          summary: '课程涉及财务数据分析、投资决策模型、财务数据挖掘、财务价值分析等内容。',
          caseText: '成功案例：国家能源集团-财务共享中心',
          tags: ['财务分析', '投资决策', '数据挖掘', '工信部证书'],
          route: '/training/data-analysis',
          external: false,
          gradient: 'linear-gradient(135deg, #1a73e8, #0e5bbf)',
          date: '2026'
        },
        {
          id: 2,
          name: 'AI大预言模型实践培训（中高级）',
          category: '企业内训（培训 + 工信部证书）',
          filterCat: '企业内训',
          summary: '课程涉及大语言模型基础、Agent、智能问答、智能数据处理等内容。',
          caseText: '成功案例：国家电网-信息化相关部门',
          tags: ['大语言模型', 'Agent', '智能问答', '工信部证书'],
          route: '/training/ai-practical',
          external: false,
          gradient: 'linear-gradient(135deg, #6366f1, #4338ca)',
          date: '2026'
        },
        {
          id: 3,
          name: '数据管理分析与治理（中高级）',
          category: '企业内训（培训 + 工信部证书）',
          filterCat: '企业内训',
          summary: '课程涉及数据管理基础、数据分析、数据挖掘、数据治理、数据价值等内容。',
          caseText: '成功案例：Sensenta- 供应链部门',
          tags: ['数据管理', '数据分析', '数据治理', '工信部证书'],
          route: '/training/data-management',
          external: false,
          gradient: 'linear-gradient(135deg, #0891b2, #0e7490)',
          date: '2026'
        },
        {
          id: 4,
          name: '首席数据官CDO（实践班）培训（中高级）',
          category: '中高管研修',
          filterCat: '中高管研修',
          summary: '课程涉及数据管理基础、数据分析、数据挖掘、数据治理、数据价值等内容。',
          caseText: '成功案例：工信部联合项目，已举办15期',
          tags: ['CDO', '数据战略', '数据资产', '高管研修'],
          route: '/training/cdo',
          external: false,
          gradient: 'linear-gradient(135deg, #0E1F52, #1F3F8F)',
          date: '2026'
        },
        {
          id: 5,
          name: 'AI 专项实战',
          category: 'AI专项实战',
          filterCat: 'AI专项实战',
          summary: '课程涉及大模型应用、提示词工程、AI agent等内容。',
          caseText: '成功案例：工信部联合项目，已举办15期',
          tags: ['大模型应用', '提示词工程', 'AI Agent'],
          route: '/training/cdo',
          external: false,
          gradient: 'linear-gradient(135deg, #7c3aed, #5b21b6)',
          date: '2026'
        },
        {
          id: 6,
          name: '审计风控合规（数据|AI）建设',
          category: '审计风控实训',
          filterCat: '审计风控实训',
          summary: '课程涉及审计数字化、风险管理数字化、AI审计、大数据风控等。',
          caseText: '成功案例：工信部联合项目，已举办15期',
          tags: ['审计数字化', '风险管理', 'AI审计', '大数据风控'],
          route: '/training/cdo',
          external: false,
          gradient: 'linear-gradient(135deg, #dc2626, #991b1b)',
          date: '2026'
        },
        {
          id: 7,
          name: '2026年度计划',
          category: '2026 计划',
          filterCat: '2026 计划',
          summary: '2026年全年、内训、公开课、联合课程、认证课程安排计划。',
          caseText: '已举办多期',
          tags: ['年度计划', '内训', '公开课', '认证课程'],
          route: '/training/corporate-training',
          external: false,
          gradient: 'linear-gradient(135deg, #059669, #047857)',
          date: '2026'
        },
        {
          id: 8,
          name: 'AI大模型应用实战',
          category: '企业内训（培训 + 工信部证书）',
          filterCat: 'AI专项实战',
          summary: '掌握AI大模型核心技能，课程偏向模型及算法开发，偏向实践应用。课程天数：5天实战。认证证书：AI 实践应用证书，颁发机构：工信部教考中心。',
          caseText: '2026热门课程',
          tags: ['大模型', 'AI实战', '算法开发', '工信部证书'],
          route: '/training/ai-practical',
          external: false,
          gradient: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
          date: '2026'
        },
        {
          id: 9,
          name: 'CDGA数据治理工程师',
          category: '认证培训',
          filterCat: '认证培训',
          summary: '面向数据专员及数字化转型人员，了解数据治理基本概念、框架、体系，培养基础数据素养。课程天数：4天精讲。认证证书：CDGA/CDGP/CDMP，颁发机构：DAMA 协会。',
          caseText: '认证课程',
          tags: ['CDGA', 'CDGP', 'CDMP', 'DAMA认证'],
          route: 'https://mp.weixin.qq.com/s/RNjo2r_LJFIxV0-xMsqKjA?scene=1&click_id=1',
          external: true,
          gradient: 'linear-gradient(135deg, #2563eb, #1e40af)',
          date: '2026'
        },
        {
          id: 10,
          name: '数字战略与企业架构',
          category: '企业内训',
          filterCat: '企业内训',
          summary: '企业架构与战略规划，数字化供应链管理，业财融合与精益运营，数字营销与客户洞察，智能决策与分析。',
          caseText: '数字化转型方向',
          tags: ['企业架构', '数字供应链', '业财融合', '智能决策'],
          route: '/training/data-analysis',
          external: false,
          gradient: 'linear-gradient(135deg, #0284c7, #0369a1)',
          date: '2026'
        },
        {
          id: 11,
          name: '数据治理能力建设（DGBOK）',
          category: '企业内训',
          filterCat: '企业内训',
          summary: '数据治理体系、数据架构与建模、数据质量管理、主数据管理、数据安全与隐私保护。',
          caseText: '数据能力建设方向',
          tags: ['数据治理', '数据架构', '数据质量', '主数据'],
          route: '/training/data-management',
          external: false,
          gradient: 'linear-gradient(135deg, #0891b2, #155e75)',
          date: '2026'
        },
        {
          id: 12,
          name: 'AI应用实践（大模型/RAG/Agent）',
          category: 'AI专项实战',
          filterCat: 'AI专项实战',
          summary: '大模型精调与RAG、AI agent搭建、计算机视觉落地、预测性维护、大模型实践案例。',
          caseText: 'AI应用实践方向',
          tags: ['大模型精调', 'RAG', 'AI Agent', '计算机视觉'],
          route: '/training/ai-practical',
          external: false,
          gradient: 'linear-gradient(135deg, #7c3aed, #4c1d95)',
          date: '2026'
        },
        {
          id: 13,
          name: '审计与风控数字化实践',
          category: '审计风控实训',
          filterCat: '审计风控实训',
          summary: '数字化审计、风险智能预警、大数据审计、人工智能审计、合规科技。',
          caseText: '审计与风控方向',
          tags: ['数字化审计', '风险预警', '大数据审计', 'AI审计'],
          route: '/training/cdo',
          external: false,
          gradient: 'linear-gradient(135deg, #e11d48, #9f1239)',
          date: '2026'
        }
      ]
    }
  },
  computed: {
    filteredCourses() {
      if (this.activeCategory === '全部') return this.courses
      return this.courses.filter(c => c.filterCat === this.activeCategory)
    }
  },
  methods: {
    goToDetail(course) {
      if (course.external) {
        window.open(course.route, '_blank')
      } else {
        this.$router.push(course.route)
      }
    }
  }
}
</script>

<style scoped>
.section-padding { padding-top: 25px; padding-bottom: 50px; }
.h1-title { font-size: 42px; line-height: 1.2; font-weight: 700; }
.h2-title { font-size: 28px; line-height: 1.3; font-weight: 700; }

.courses {
  min-height: 600px;
  padding: 60px 0;
}

.page-header {
  text-align: center;
  margin-bottom: 60px;
}

.page-header h1 {
  font-size: 42px;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.page-header p {
  font-size: 18px;
  color: var(--text-secondary);
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.case-card {
  background-color: var(--white);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  cursor: pointer;
}

.case-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.case-image {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.case-placeholder {
  color: var(--white, #fff);
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  padding: 0 20px;
  text-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.case-content {
  padding: 24px;
}

.case-content h3 {
  font-size: 18px;
  color: var(--text-primary);
  margin-bottom: 8px;
  line-height: 1.4;
}

.company {
  color: var(--brand-blue, #1F3F8F);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}

.description {
  color: var(--text-secondary, #5A5E66);
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 16px;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  background-color: var(--porcelain-blue, #EAF0FB);
  color: var(--brand-blue, #1F3F8F);
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
